/* BlankApparel: gentle app download prompts.
   - Floating card once per visit after a pause, max 3 times, quiet for 21 days after "x" and 90 days after a tap.
   - A quiet line on product pages and in the cart.
   - Never inside the app, on checkout/account/cart pages for the card, or on iPhone Safari (Apple's own banner shows there). */
(function () {
  'use strict';
  var el = document.getElementById('ba-app-cfg');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }

  var ua = navigator.userAgent || '';
  var isAndroid = /Android/i.test(ua);
  var isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var mobile = isAndroid || isIOS;
  var iosSafari = isIOS && /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\/|Instagram|FBAN|FBAV|Line\//i.test(ua);
  var inApp = /BlankApparel/i.test(ua);
  var DAY = 864e5;
  var now = Date.now();

  function storeUrl(src) {
    if (isAndroid) return cfg.android + '&referrer=' + encodeURIComponent('utm_source=website&utm_medium=' + src);
    if (isIOS) return cfg.ios;
    return cfg.page;
  }

  // QR codes point at the app page with ?go=app: phones go straight to their store.
  if (/[?&]go=app\b/.test(location.search) && mobile) {
    location.replace(storeUrl('qr'));
    return;
  }
  if (inApp || cfg.design) return;

  function load(k) { try { return JSON.parse(localStorage.getItem(k)) || {}; } catch (e) { return {}; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function track(ev, src) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('ba_app_' + ev, { source: src }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'ba_app_' + ev, ba_source: src }); } catch (e) {}
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function storeLabel() { return isAndroid ? 'Google Play' : isIOS ? 'App Store' : ''; }

  var tpl = cfg.template || '';
  var onProduct = tpl === 'product';
  var onCart = tpl === 'cart';
  var onAppPage = location.pathname.indexOf(cfg.page) === 0;

  /* ---------- 1. Floating card ---------- */
  function floating() {
    if (onProduct || onCart || onAppPage || /^customers/.test(tpl) || tpl === 'password' || tpl === '404') return;
    if (iosSafari) return; // Apple's Smart App Banner handles iPhone Safari
    var st = load('ba_app');
    if ((st.until && st.until > now) || (st.n || 0) >= 3) return;
    try { if (sessionStorage.getItem('ba_app_s')) return; } catch (e) {}

    var dealer = cfg.dealer;
    var title = dealer ? 'Your dealer prices, in your pocket' : 'Ordering is quicker in the app';
    var sub = dealer
      ? 'Same login. Live stock by size, one-tap reorders and pickup slots.'
      : 'Live stock by size, dealer prices and one-tap reorders. Free for resellers.';

    var card = document.createElement('aside');
    card.className = 'ba-appn' + (mobile ? ' ba-appn--phone' : '');
    card.setAttribute('aria-label', 'Get the BlankApparel.in app');
    card.innerHTML =
      '<img class="ba-appn__icon" src="' + esc(cfg.icon) + '" alt="" width="48" height="48">' +
      '<div class="ba-appn__body">' +
        '<p class="ba-appn__t">' + esc(title) + '</p>' +
        '<p class="ba-appn__s">' + esc(sub) + '</p>' +
        '<div class="ba-appn__row">' +
          '<a class="ba-appn__cta" data-go href="' + esc(storeUrl('first_visit')) + '" target="_blank" rel="noopener">Get the app</a>' +
          (storeLabel() ? '<span class="ba-appn__meta">on <b>' + storeLabel() + '</b></span>' : '') +
        '</div>' +
        '<div class="ba-appn__qr"><img src="' + esc(cfg.qr) + '" alt="QR code to download the BlankApparel.in app" width="92" height="92" loading="lazy">' +
          '<p>Scan with your phone camera to get the app.<br><a data-go href="' + esc(cfg.ios) + '" target="_blank" rel="noopener">App Store</a> · <a data-go href="' + esc(cfg.android) + '" target="_blank" rel="noopener">Google Play</a></p></div>' +
      '</div>' +
      '<button type="button" class="ba-appn__x" aria-label="Not now">&times;</button>';

    function close(days) {
      st.until = Date.now() + days * DAY;
      save('ba_app', st);
      card.classList.remove('is-in');
      document.documentElement.classList.remove('ba-appn-on');
      setTimeout(function () { card.remove(); }, 450);
    }
    card.querySelector('.ba-appn__x').addEventListener('click', function () { track('dismiss', 'first_visit'); close(21); });
    card.querySelectorAll('[data-go]').forEach(function (a) {
      a.addEventListener('click', function () { track('click', 'first_visit'); close(90); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && card.isConnected) close(21); });

    // Wait for a calm moment: never on top of an open drawer, menu, sheet or toast.
    function locked(n) { var o = getComputedStyle(n).overflowY; return o === 'hidden' || o === 'clip'; }
    function busy() {
      return locked(document.body) || locked(document.documentElement) ||
        document.querySelector('cart-drawer.active, .ba-toast.is-in, .ba-kitnudge.is-on, dialog[open]');
    }
    var tries = 0;
    function show() {
      if (busy() && tries++ < 6) { setTimeout(show, 4000); return; }
      document.body.appendChild(card);
      document.documentElement.classList.add('ba-appn-on');
      requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('is-in'); }); });
      st.n = (st.n || 0) + 1;
      save('ba_app', st);
      try { sessionStorage.setItem('ba_app_s', '1'); } catch (e) {}
      track('shown', 'first_visit');
    }
    // A short pause after landing, a bit sooner if they are already scrolling.
    var t = setTimeout(show, 9000), scrolled = false;
    window.addEventListener('scroll', function onS() {
      if (scrolled || window.scrollY < 500) return;
      scrolled = true;
      window.removeEventListener('scroll', onS);
      clearTimeout(t);
      t = setTimeout(show, 2500);
    }, { passive: true });
  }

  /* ---------- 2. Product page line ---------- */
  function productLine() {
    if (!onProduct) return;
    var st = load('ba_app_pdp');
    if (st.until && st.until > now) return;
    var anchor = document.querySelector('.ba-pdp__info .ba-actions') || document.querySelector('.ba-stock');
    if (!anchor || document.querySelector('.ba-appline')) return;

    var box = document.createElement('div');
    box.className = 'ba-appline';
    box.innerHTML =
      '<img class="ba-appline__icon" src="' + esc(cfg.icon) + '" alt="" width="40" height="40" loading="lazy">' +
      '<p class="ba-appline__txt"><b>Waiting on a size?</b>Get restock alerts and live stock in the app<span>, plus one-tap reorders</span>.</p>' +
      (mobile
        ? '<a class="ba-appline__cta" data-go href="' + esc(storeUrl('product')) + '" target="_blank" rel="noopener">Get app</a>'
        : '<button type="button" class="ba-appline__cta" data-qr aria-expanded="false">Scan QR</button>' +
          '<div class="ba-appline__pop" role="dialog" aria-label="Scan to get the app"><img src="' + esc(cfg.qr) + '" alt="QR code to download the BlankApparel.in app" width="150" height="150" loading="lazy">Scan with your phone camera</div>') +
      '<button type="button" class="ba-appline__x" aria-label="Hide">&times;</button>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);

    box.querySelector('.ba-appline__x').addEventListener('click', function () {
      save('ba_app_pdp', { until: Date.now() + 30 * DAY });
      track('dismiss', 'product');
      box.remove();
    });
    var go = box.querySelector('[data-go]');
    if (go) go.addEventListener('click', function () { track('click', 'product'); });
    var qr = box.querySelector('[data-qr]');
    if (qr) {
      qr.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = box.classList.toggle('is-pop');
        qr.setAttribute('aria-expanded', open);
        if (open) track('qr', 'product');
      });
      document.addEventListener('click', function (e) {
        if (!box.contains(e.target)) { box.classList.remove('is-pop'); qr.setAttribute('aria-expanded', 'false'); }
      });
    }
  }

  /* ---------- 3. Cart line (cart page and drawer) ---------- */
  function cartLines() {
    var ctas = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < ctas.length; i++) {
      var c = ctas[i];
      if (c.nextElementSibling && c.nextElementSibling.classList.contains('ba-appcart')) continue;
      var p = document.createElement('p');
      p.className = 'ba-appcart';
      p.innerHTML = '<img src="' + esc(cfg.icon) + '" alt="" width="20" height="20" loading="lazy">' +
        '<span>Reorder this whole run in one tap next time. <a data-go href="' + esc(mobile ? storeUrl('cart') : cfg.page) + '"' + (mobile ? ' target="_blank" rel="noopener"' : '') + '>Get the app</a></span>';
      p.querySelector('[data-go]').addEventListener('click', function () { track('click', 'cart'); });
      c.parentNode.insertBefore(p, c.nextSibling);
    }
  }

  function init() {
    // The older always-on mobile app bar (sections/ba-extras) is replaced by these prompts.
    var old = document.querySelector('[data-ba-appbar]');
    if (old) { old.hidden = true; document.documentElement.classList.remove('has-appbar'); }
    floating();
    productLine();
    cartLines();
    // The cart drawer re-renders its contents after every change.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending;
      new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(cartLines, 60); })
        .observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
